import { MapIcon } from "@heroicons/react/24/outline";
import { CircleStackIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

const incentives = [
  {
    name: "Explore Interactive Map",
    Icon: MapIcon,
    description:
      "View and explore voting patterns in various states down to senatorial data as far back as 2015 elections",
  },
  {
    name: "View Past Electoral Historical Data",
    Icon: CircleStackIcon,
    description:
      "View past governorship and presidential election data on the go to build your statistical knowledge ",
  },
];

export default function IntroSection() {
  return (
    <div className="bg-black">
      <div className="mx-auto max-w-7xl py-10 sm:px-2 lg:px-4">
        <div className="mx-auto max-w-2xl px-4 lg:max-w-none">
          <div className="mt-16 grid grid-cols-1 gap-y-10 gap-x-8 lg:grid-cols-2">
            {incentives.map(({ name, description, Icon }) => (
              <div key={name} className="flex flex-col">
                <div className=" flex justify-center">
                  <Icon className=" text-white h-12" />
                </div>
                <div className="mt-4 text-center sm:mt-0 sm:ml-6 lg:mt-6 lg:ml-0">
                  <h3 className="text-sm font-medium text-white">{name}</h3>
                  <p className="mt-2 text-sm text-gray-300">{description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-16 flex justify-center">
            <Link
              to="/map"
              className="inline rounded-md border border-transparent bg-white px-8 py-3 text-base font-medium text-gray-900 hover:bg-gray-100 md:py-4 md:px-10 md:text-lg"
            >
              View Interactive Map
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
